(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';

/* ── IntersectionObserver reveals ── */
var obs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){ e.target.classList.add('on'); obs.unobserve(e.target); }
  });
},{ threshold:0.1, rootMargin:'0px 0px -40px 0px' });
document.querySelectorAll('.revel').forEach(function(el){ obs.observe(el); });

/* ── Sticky mobile bar ── */
var stickyBar = document.getElementById('sticky-bar');
window.addEventListener('scroll', function(){
  stickyBar.classList.toggle('show', window.scrollY > 700);
},{ passive:true });

/* ── FAQ accordion ── */
document.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click', function(){
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i){
      i.classList.remove('open');
      i.querySelector('.faq-q').setAttribute('aria-expanded','false');
    });
    if(!isOpen){
      item.classList.add('open');
      btn.setAttribute('aria-expanded','true');
    }
  });
});

/* ══ HERO WAITLIST DRAWER ══ */
var waitlistBtn     = document.getElementById('hero-waitlist-btn');
var waitlistBtnTxt  = document.getElementById('hero-waitlist-btn-text');
var waitlistChevron = document.getElementById('hero-waitlist-chevron');
var drawer          = document.getElementById('hero-email-drawer');
var nativeForm      = document.getElementById('hero-native-form');
var nativeSuccess   = document.getElementById('hero-native-success');
var klaviyoEmbed    = document.getElementById('hero-klaviyo-embed');
var drawerOpen      = false;

function openDrawer(){
  drawerOpen = true;
  drawer.classList.add('open');
  waitlistBtn.classList.add('active');
  waitlistBtn.setAttribute('aria-expanded','true');
  waitlistBtnTxt.textContent = 'Hide';
  waitlistChevron.style.transform = 'rotate(180deg)';
  setTimeout(function(){ drawer.scrollIntoView({ behavior:'smooth', block:'nearest' }); }, 80);
  if(window._klOnsite && typeof window._klOnsite.push === 'function'){
    try{ window._klOnsite.push(['openForm','VQtEYL']); }catch(err){}
  }
  setTimeout(function(){
    var kForm = klaviyoEmbed ? klaviyoEmbed.querySelector('form,iframe,input') : null;
    if(!kForm){
      klaviyoEmbed.style.display = 'none';
      nativeForm.style.display   = 'flex';
    }
  }, 3000);
}

function closeDrawer(){
  drawerOpen = false;
  drawer.classList.remove('open');
  waitlistBtn.classList.remove('active');
  waitlistBtn.setAttribute('aria-expanded','false');
  waitlistBtnTxt.textContent = 'Join the waitlist first';
  waitlistChevron.style.transform = 'rotate(0deg)';
}

if(waitlistBtn){
  waitlistBtn.addEventListener('click', function(){ drawerOpen ? closeDrawer() : openDrawer(); });
}

if(nativeForm){
  nativeForm.addEventListener('submit', function(e){
    e.preventDefault();
    var emailInput = document.getElementById('hero-email-input');
    var email = emailInput ? emailInput.value.trim() : '';
    if(!email) return;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VQtEYL',{
      method:'POST',
      headers:{'content-type':'application/json','revision':'2023-02-22'},
      body:JSON.stringify({data:{type:'subscription',attributes:{list_id:'YOUR_LIST_ID',email:email}}})
    }).then(showNativeSuccess).catch(showNativeSuccess);
  });
}

function showNativeSuccess(){
  if(nativeForm) nativeForm.style.display = 'none';
  if(nativeSuccess) nativeSuccess.style.display = 'block';
}

/* ── Smooth scroll for anchor CTAs ── */
document.querySelectorAll('a[href="#convert"]').forEach(function(a){
  a.addEventListener('click', function(e){
    e.preventDefault();
    var target = document.getElementById('convert');
    if(target) target.scrollIntoView({ behavior:'smooth', block:'start' });
  });
});

})();

  } catch(e) { console.error(e); }
})();
})();
